import { render, staticRenderFns } from "./EditContactUs.vue?vue&type=template&id=5c21fece&scoped=true&"
import script from "./EditContactUs.vue?vue&type=script&lang=js&"
export * from "./EditContactUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21fece",
  null
  
)

export default component.exports